<template>
  <div>
    <div
      class="modal animated fadeIn"
      id="weeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Weekly expenses</small>
              </legend>
              <form @submit.prevent="loadWeeklyExpenses()">
                <div class="row">
                  <input type="hidden" class="accounttype_id" :value="Accounttype.id" />
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                    <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingWeeklyExpenses">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingWeeklyExpensesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>

    <div
      class="modal animated fadeIn"
      id="fullweeklyexpensesModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <fieldset class="border p-3">
              <legend>
                <small style="font-size: 15px; font-weight: bold">Weekly expenses</small>
              </legend>
              <form @submit.prevent="loadFullWeeklyExpenses()">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>From date</label>
                      <input
                        type="date"
                        class="form-control from_full_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>End date</label>
                      <input
                        type="date"
                        class="form-control end_full_date"
                        placeholder="daily expenses date"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <button type="button" class="btn btn-danger btn-flat" data-dismiss="modal">
                      <i class="fa fa-times"></i> Cancel
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button type="submit" class="btn btn-primary btn-flat creatingFullWeeklyExpenses">
                      <i class="fa fa-file-pdf-o"></i> Print
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary btn-flat creatingFullWeeklyExpensesLoader"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i class="fa fa-spinner fa-spin" style="font-size:24px"></i> please wait...
                    </button>
                  </div>
                </div>
              </form>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage account types</small>
      </legend>
      <button
        type="button"
        class="btn btn-success btn-roundec"
        data-toggle="modal"
        data-target="#fullweeklyexpensesModal"
      >
        <i class="fa fa-file-pdf-o"></i> Weekly expenses
      </button>
      <p></p>
      <div></div>
      <div class="accounttypesLoader">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        <i class="fa fa-spinner fa-spin" style="font-size:24px; color: blue"></i>loading accounttypes...
      </div>
      <vue-good-table
        :columns="columns"
        :rows="systemAccounttypes"
        :fixed-header="true"
        :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'Action'">
            <button
              type="button"
              class="btn btn-primary btn-roundec"
              data-toggle="modal"
              data-target="#weeklyexpensesModal"
              @click="viewAccounttype(props.row.id)"
            >
              <i class="fa fa-file-pdf-o"></i> Weekly expenses
            </button>
          </span>
        </template>
      </vue-good-table>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Account code",
          field: "account_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by accounttype code"
          }
        },
        {
          label: "Account name",
          field: "account_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter by account name"
          }
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          type: "text"
        }
      ]
    };
  },
  created() {
    this.loadAccounttypes();
  },
  computed: {
    ...mapGetters(["systemAccounttypes", "Accounttype"])
  },
  methods: {
    ...mapActions(["loadAccounttypes", "loadWeeklyExpenses", "viewAccounttype", "loadFullWeeklyExpenses"])
  }
};
</script>
<style scoped>
.creatingWeeklyExpensesLoader {
  display: none;
}
.creatingFullWeeklyExpensesLoader{
  display: none;
}

</style>


// WEBPACK FOOTER //
// src/reports/weeklyexpenses.vue